import { z } from "zod";

export const disconnectVehicleFromProviderPayloadSchema = z.object({
  vehicleUuid: z.uuid(),
  updatedBy: z.string(),
});

export type DisconnectVehicleFromProviderPayload = z.infer<
  typeof disconnectVehicleFromProviderPayloadSchema
>;
